/** Organization ID for the Impact Report */
export const ORGID = "365"; //360 for production, this is for testing. TODO: This actually seems correct, so more digging is needed
export * from "./cleaner.js";
export * from "./connector.js";
export * from "./types/company.js";
export * from "./types/processed.js";
export { convertImpacts } from "./impacts.js";
export { descriptionMap } from "./impacts.js";
export * from "./types/index.js";
